import React from 'react'
import DatePicker from 'react-datepicker'

import { InputStyled } from '../Input/Input.styles'

interface Props {
  className?: string
  endHour?: number
  handleChange: (value: Date) => void
  startHour?: number
  timeIntervals?: number
  timeZone?: string
  value: Date
}

export const DateTimeInput = ({
  className = '',
  startHour,
  endHour,
  handleChange,
  timeIntervals = 15,
  timeZone,
  value,
}: Props) => {
  const onChange = (value: Date) => {
    handleChange(value)
  }

  const minimumTime = startHour ? new Date().setHours(startHour, 0) : undefined
  const maximumTime = endHour ? new Date().setHours(endHour, 0) : undefined

  return (
    <DatePicker
      className={className}
      css={InputStyled}
      dateFormat="MM/dd/yyyy, h:mmaaa z"
      maxTime={maximumTime}
      minTime={minimumTime}
      onChange={onChange}
      placeholderText={'Select date & time'}
      selected={value}
      showPopperArrow={false}
      showTimeSelect={true}
      timeIntervals={timeIntervals}
      timeZone={timeZone}
      value={value}
    />
  )
}
